import React, { useState,useEffect } from 'react'
import './Authentication.css'

const Authentication = () => {
  const [user, setUser] = useState("login")
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, []);
  return (

    <>
       <div className="floating-icons">
        <a className="icon">
          <button

            className="sm_icon"
          >
            <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
          </button>
        </a>
        <a className="icon">
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
          </button>
        </a>
        <a className="icon">
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
          </button>
        </a>
        <a className="icon">
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
          </button>
        </a>
      </div>
    
    <div className='Authentication_section' style={{ marginTop: "50px", marginBottom: "50px" }}>
      <div className='container-fluid'>
        <div className='Authentication_section_heads'>
          <h1>Personalized Access for Your Profile</h1>
          <p>Effortlessly manage your credentials with our streamlined authentication system. Whether you're logging in, signing up, or resetting your password, our user-friendly interface ensures a seamless and secure experience. Stay protected with advanced encryption and multi-factor authentication options.</p>
        </div>
        {
          user === "login" && (
            <div className='row'>
              <div className='col-md-6 Authemtication_bg p-0'>

              </div>
              <div className='col-md-6 p-0'>
                <div className='Authemtication_inputs'>
                  <div className='card'>
                    <div className='login_card_content'>
                      <h2>Welcome Back!</h2>
                      <p>Access your account to continue your journey with us.</p>
                    </div>
                    <form>
                      <div className="email-input-container">
                        <i className="ri-mail-line email-icon"></i>
                        <input type="email" placeholder="Enter your email" className="email-input" />
                      </div>

                      <div className="email-input-container">
                        <i class="ri-lock-password-line email-icon"></i>
                        <input type="password" placeholder="Enter your password" className="email-input" />
                      </div>
                      <div className='text-right'>
                        <a href='#'>Forgot password</a>
                      </div>
                      <button>Log in</button>

                    </form>

                    <div>
                      <p>I Don't have an account ? <span onClick={() => setUser("signup")} style={{ cursor: "pointer" }}>Sign up</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {
          user === "signup" && (
            <div className='row'>
              <div className='col-md-6 Authemtication_bg1 p-0'>

              </div>
              <div className='col-md-6 p-0'>
                <div className='Authemtication_inputs'>
                  <div className='card'>
                    <div className='login_card_content'>
                      <h2>Create Your Account!</h2>
                      <p>Join us today and take the first step toward your exciting journey.</p>
                    </div>
                    <form>
                      <div className="email-input-container">
                        <i class="ri-shield-user-line email-icon"></i>
                        <input type="text" placeholder="Enter your Name" className="email-input" />
                      </div>
                      <div className="email-input-container">
                        <i className="ri-mail-line email-icon"></i>
                        <input type="email" placeholder="Enter your email" className="email-input" />
                      </div>


                      <div className="email-input-container">
                        <i class="ri-phone-line email-icon"></i>
                        <input type="number" placeholder="Enter your contact number" className="email-input" />
                      </div>



                      <div className="email-input-container">
                        <i class="ri-lock-password-line email-icon"></i>
                        <input type="password" placeholder="Enter your password" className="email-input" />
                      </div>

                      <div className="email-input-container">
                        <i class="ri-lock-password-line email-icon"></i>
                        <input type="password" placeholder="Enter your Confirm password" className="email-input" />
                      </div>


                      {/* <div className='text-right'>
                        <a href='#'>Forgot password</a>
                      </div> */}
                      <button>Sign up</button>

                    </form>

                    <div>
                      <p>Alreday i have an account ? <span onClick={() => setUser("login")} style={{ cursor: "pointer" }}>Log in</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
    </>
  )
}

export default Authentication
